<template>
  <!-- needed ref="thead" to eliminate the vuesax error -->
  <tbody ref="thead">
    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in rows || []">
      <vs-td>
        <vs-chip :color="getOrderStatusColor(tr.status)">{{
          tr.status
        }}</vs-chip>
      </vs-td>
      <vs-td>
        <p v-if="tr.location && tr.location.name">{{ tr.location.name }}</p>
      </vs-td>
      <vs-td>
        <router-link
          :to="{ name: 'edit-contact', params: { id: tr.visitor.id } }"
          ><h5>
            {{ getVisitorName(tr) }}
          </h5></router-link
        >
      </vs-td>
      <vs-td>
        <p>{{ (tr.visitor.contactType || {}).name || 'N/a' }}</p>
      </vs-td>
      <vs-td>
        <p>{{ tr.visitor.companyName || 'N/a' }}</p>
      </vs-td>
      <vs-td>
        <p v-if="tr.hostedBy">{{ `${tr.hostedBy.firstName} ${tr.hostedBy.lastName}` }}</p>
        <p v-else>N/a</p>
      </vs-td>
      <vs-td>
        <p>{{ tr.checkinTime | longDate }}</p>
      </vs-td>
      <vs-td>
        <p v-if="tr.checkoutTime">{{ tr.checkoutTime | longDate }}</p>
        <vs-button
          v-if="!tr.checkoutTime"
          size="small"
          @click.prevent="methods.signout(tr.id)"
          icon-pack="feather"
          icon="icon-check"
          icon-before
          >Sign Out</vs-button
        >
      </vs-td>
      <vs-td class="whitespace-no-wrap text-right">
        <span v-if="$route.name !== 'dashboard'">8</span>
        <div v-else class="">
          <router-link
            :to="{ name: 'edit-contact', params: { id: tr.visitor.id } }"
          >
            <feather-icon
              icon="EditIcon"
              svgClasses="w-5 h-5 hover:text-primary stroke-current"
            />
          </router-link>
          <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteItem(tr.id)" />
        </div>
      </vs-td>
    </vs-tr>
  </tbody>
</template>

<script>
export default {
  props: ['rows', 'methods'],
  methods: {
    clicktr () { }, // needed to eliminate the error this.$parent.clicktr
    deleteItem (id) {
      this.$store.dispatch('visitManagement/deleteVisitById', {id, route: this.$route});
      this.methods.fetchDataWithFiltering();
    },
    getVisitorName(tr) {
      const { visitor, parentVisit } = tr;
      let { firstName, lastName, isDependant } = visitor;
      firstName = firstName || "";
      lastName = lastName || "";

      if (isDependant) {
        const parentVisitor = (parentVisit || {}).visitor || {};
        const parentVisitorFirstName = (parentVisitor || {}).firstName || "";
        const parentVisitorLastName = (parentVisitor || {}).lastName || "";
        return `Dependant of ${parentVisitorFirstName} ${parentVisitorLastName}`;
      }

      return `${firstName} ${lastName}`;
    }
  },
  created() { }
}
</script>
